import { BASE_API_URL } from "~/utils/apiUrl";
import {
  KNOWLEDGE_DOCUMENT_UPLOAD_TYPES,
  toDropzoneAcceptRecord,
} from "~/utils/uploadContentType";

export const SKY_ACCOUNT_CREATED = "sky_account_created";
export const SKY_SELECTED_ORGANIZATION_ID = "skySelectedOrganizationId";

export const THEME_STORAGE_KEY = "sky-theme";
export type Theme = "light" | "dark" | "system";
export const THEMES: Theme[] = ["light", "dark", "system"];
export const SKY_LAST_TRANSCRIBED_TEXT = "sky_last_transcribed_text";
export const ACCEPTED_FILE_TYPES = {
  "application/pdf": [".pdf"],
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document": [
    ".docx",
  ],
  "image/png": [".png"],
  "image/jpeg": [".jpg", ".jpeg"],
  "audio/mpeg": [".mp3"],
  "audio/wav": [".wav"],
  "audio/mp4": [".mp4"],
  "audio/x-m4a": [".m4a"],
  "video/mp4": [".mp4"],
};

export const ACCEPTED_KNOWLEDGE_FILE_TYPES = toDropzoneAcceptRecord(
  KNOWLEDGE_DOCUMENT_UPLOAD_TYPES
);

export const AMPLITUDE_API_KEY = "651d126461839884d4455430b6a02104";
export const AMPLITUDE_SERVER_URL = `${BASE_API_URL}/organizations/behavior`;

export const CALENDLY_URL = "https://calendly.com/farrell-usesky/request-demo";
export const DEMO_CASE_NAME = "Case #1 Voice Recording";

export const DEMO_CASE_STEPS = [
  { title: "Creating Case", description: "Please wait a moment" },
  { title: "Preparing File", description: "Please wait a moment" },
  { title: "Uploading File", description: "Please wait a moment" },
];

/**
 * Sentinel tokens used by the AI content extraction pipeline.
 * These tokens wrap page content to validate completeness during processing.
 * They should be stripped before displaying content to users.
 */
export const SKY_PAGE_SENTINEL_START = "<SKY_PAGE_START>";
export const SKY_PAGE_SENTINEL_END = "<SKY_PAGE_END>";

/**
 * Regex pattern to match and strip sentinel tokens from content.
 * Matches both opening and closing tags.
 */
export const SKY_PAGE_SENTINEL_PATTERN = new RegExp(
  `${SKY_PAGE_SENTINEL_START}|${SKY_PAGE_SENTINEL_END}`,
  "g"
);

/**
 * Strips sentinel tokens from content.
 * These tokens are used internally for validation and should not be displayed to users.
 */
export function stripSentinelTags(content: string): string {
  return content.replace(SKY_PAGE_SENTINEL_PATTERN, "").trim();
}
